import * as React from "react";
import { forwardRef } from "react";
const SvgMarkRejected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 8, viewBox: "2 2 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 3L3 9", stroke: "white", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3 3L9 9", stroke: "white", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgMarkRejected);
export { ForwardRef as ReactComponent };
